import { z } from "zod";
import { MeetingAttendeeStatus } from "../enum.js";

export const respondMeetingSchema = z
	.object({
		action: z.enum(MeetingAttendeeStatus),
		reason: z.string().max(500).optional(),
	})
	.strict();

export type RespondMeetingPayload = z.infer<typeof respondMeetingSchema>;
